// extracted by mini-css-extract-plugin
module.exports = {"ArticleByline":"ArticleByline_ArticleByline___9Yd3","ArticleByline_name":"ArticleByline_ArticleByline_name__wUsq6","ArticleByline_title":"ArticleByline_ArticleByline_title__eNyS4"};